import Vue from 'vue'
import App from './App.vue'
import store from './store'
import ApiService from './services/ApiService.js';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCalendar } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faCalendar)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(require('vue-moment'));
Vue.config.productionTip = false

import './style.scss';

document.addEventListener('DOMContentLoaded', function(){
    let api_url = document.getElementById('gfo_switchsupport_app').getAttribute('data-api_url');
    let api_token = document.getElementById('gfo_switchsupport_app').getAttribute('data-api_token');
    store.commit('api_url', api_url);
    store.commit('api_token', api_token);
    store.commit('ApiService', ApiService);
    let query = {};
    let parts = location.search.substr(1).split('&');
    parts.forEach(function(p){
        let a = p.split('=');
        if (2 == a.length){
            query[a[0]] = a[1];
        }
    });
    store.commit('current_component', {component:'', props: {}});
    if(query.order_reference){
        store.commit('order_reference', query.order_reference);
    } else {
        store.commit('order_reference', '');
    }
    new Vue({
      store,
      render: h => h(App)
    }).$mount('#gfo_switchsupport_app')
});
